module.exports = __webpack_public_path__ + "static/img/img38.aab8ff2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img38.png
// module id = elQI
// module chunks = 1